// ─────────────────────────────────────────────────────────────────────
// Champion URL aliases
// ─────────────────────────────────────────────────────────────────────
//
// Riot's internal champion id and the alias u.gg carries in its URLs are the
// same string for every champion but one: riot's "MonkeyKing" is "wukong" on
// u.gg. riot-assets already encodes that when it resolves a numeric id to a
// name (RAC_getNormalizedChampionName in
// packages/riot-assets/src/context-functions/champions.js) — but that path
// needs championMini, which is an async fetch.
//
// This is the same mapping applied at the STRING level, for code that only
// ever sees the URL alias and deliberately avoids that lookup: the League
// Classic roster gate and the Classic URL builder both key on the alias
// precisely so the "Classic" tab can be decided with zero fetches at server
// render (see CLASSIC_COUNTERPART_ALIASES).
//
// Without it the two spellings disagree about which pages exist:
// /lol/champions/monkeyking/build is a live URL, so the nav there used to emit
// a Classic tab pointing at /lol/champions/classic/monkeyking-classic — an
// alias the Classic champion manifest (keyed "wukong") cannot resolve.
//
// Kept dependency-free on purpose so routes/app-routes.ts can import it:
// that module is deliberately light and utils/special-game-modes.ts imports
// FROM it, so a heavier import here would risk a cycle.
const CHAMPION_URL_ALIAS_SYNONYMS: Record<string, string> = {
  monkeyking: "wukong",
};

export function normalizeChampionUrlAlias(alias: string): string {
  const lower = alias.toLowerCase();
  return CHAMPION_URL_ALIAS_SYNONYMS[lower] ?? lower;
}
